import React from 'react'

export default function Title({title}) {
  return (
    <h1 className="transfer-title">{title}</h1>
  )
}
